import { ROLE } from "providers/Auth";
import { Address } from "types/landlord/address";
import { USER_PERMISSION_KEYS } from "./slices/users/constants";

export type UserPermissions = {
  -readonly [K in keyof typeof USER_PERMISSION_KEYS as (typeof USER_PERMISSION_KEYS)[K] extends string
    ? (typeof USER_PERMISSION_KEYS)[K]
    : never]: boolean;
} & {
  can_access_reports?: {
    -readonly [P in keyof (typeof USER_PERMISSION_KEYS)["CAN_ACCESS_REPORTS"]["PERMISSIONS"]]: boolean;
  };
  can_edit_idv?: {
    -readonly [P in keyof (typeof USER_PERMISSION_KEYS)["CAN_EDIT_IDV"]["PERMISSIONS"]]: boolean;
  };
};

type Property = {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
  soft_deleted_at: string | null;
  address_id: number;
  partner_id: number;
  verification_template_identifier: string | null;
  pms_id: string;
  external_id: string | null;
  address?: Address;
};

export interface User extends UserPermissions {
  id: number;
  obfuscated_id: string;
  name: string;
  email: string;
  role: ROLE;
  properties: Property[];
  property_groups: (Property & { total_properties?: number })[];
  properties_count?: number;
  property_groups_count?: number;
  property_group_properties_count?: number;
  total_properties_count?: number;
  property_ids?: number[];
  can_view_application?: boolean;
  can_override_applicant_screening_template: boolean;
  lead_assignment_eligible?: boolean;
  receives_inbound_calls?: boolean;
}
export enum SettingsUsersViews {
  Agents = "AI agents",
  Users = "Users",
  Roles = "User roles"
}
